export function getEnvByHostname() {
  const hostname = window.location.hostname;
  if (hostname === 'localhost' || hostname === '127.0.0.1') return 'TEST';
  if (hostname === 'fiat-payment-web-qa.me10.tools') return 'TEST';
  if (hostname === 'fiat-canary-sandbox.fiat.osl.com') return 'SANDBOX';
  if (hostname === 'fiat-canary.fiat.osl.com') return 'PROD';
  return 'TEST';
}
